/**
 * Per-entity offline cache configuration.
 *
 * ttlMs      — how long a cached row stays fresh before the sync engine
 *              re-fetches it from the server.
 * maxRows    — hard cap on stored rows; oldest are evicted when exceeded.
 * syncScope  — "user" rows are scoped to the current user; "tenant" to the
 *              whole tenant (admin-level pages that aggregate data).
 */

export interface EntityCacheConfig {
  ttlMs: number
  maxRows: number
  syncScope: 'user' | 'tenant'
}

export const OFFLINE_CONFIG: Record<string, EntityCacheConfig> = {
  leads: {
    ttlMs:     60 * 60 * 1000,        // 60 minutes
    maxRows:   500,
    syncScope: 'user',
  },
  customers: {
    ttlMs:     4 * 60 * 60 * 1000,   // 4 hours
    maxRows:   300,
    syncScope: 'user',
  },
  callHistory: {
    ttlMs:     24 * 60 * 60 * 1000,  // 24 hours
    maxRows:   1000,
    syncScope: 'user',
  },
}

/** Leads due within this many days are eligible for the offline cache. */
export const LEAD_CACHE_HORIZON_DAYS = 15
